import type { SearchRequest, SearchResponse } from '@empathyco/x-types'

import { XPlugin } from '@empathyco/x-components'
// @ts-strict-ignore
import { getCurrentInstance } from 'vue'

interface XService {
  search: (params: Partial<SearchRequest>) => Promise<SearchResponse>
}

// TODO: Temporary solution until X find better solution (ping Iván Tajes)
export const useXService = (): XService => {
  const {
    proxy: { $store },
  } = getCurrentInstance()

  const search = (params: Partial<SearchRequest>): Promise<SearchResponse> => {
    const xSearchRequestModule = 'x/search/request'
    const request = $store.getters[xSearchRequestModule] as SearchRequest
    return XPlugin.adapter.search({
      ...request,
      start: 0,
      ...params,
    })
  }

  return {
    search,
  }
}
